import axios from 'axios';
import { enqueueSnackbar } from 'notistack';
import { CountryModel } from 'src/models/regions/country';
import { API_url } from '../api.setup';

const API_Controller = '/countries'
const CountryService = {
  getAllCountries: async () => {
    try {
      const response = await axios.get(`${API_url}${API_Controller}/getall`);
      return response.data as CountryModel[];
    } catch (error) {
      throw error;
    }
  },

  addCountry:async (dataToUpdate) => {
    try {
      const response = await axios.post(`${API_url}${API_Controller}`, dataToUpdate)
      return response.data as CountryModel;
    } catch (error) {
      throw error;
    }
  },

  deleteCountry:  async  (countryId) => {
    try {
      const response = await axios.delete(`${API_url}${API_Controller}/delete?id=${countryId}`);
      
      return response.data ;
    } catch (error) {
      throw error;
    }
  },

  editCountry: async (editedData : CountryModel) => {
    try {
        const response = await axios.put(`${API_url}${API_Controller}/update`, editedData);
        return response.data as CountryModel;
      } catch (error) {
        throw error;
      }
  },
};

export default CountryService;
